import { COPILOT_ROLE_NAMES, normalizeCopilotRoleName } from '@/constants/copilotRoleNames';

/**
 * Une las partidas de elaboración de todos los roles del venue sin duplicar por id.
 * @param {Array<{ elaborationStations?: Array<{ id: unknown; name?: string }> }>} roles
 * @returns {Array<{ id: unknown; name?: string }>}
 */
export function collectUniqueElaborationStations(roles) {
	if (!Array.isArray(roles)) {
		return [];
	}

	const byId = new Map();

	for (const role of roles) {
		for (const station of role?.elaborationStations || []) {
			if (station?.id == null) {
				continue;
			}
			const key = String(station.id);
			if (!byId.has(key)) {
				byId.set(key, station);
			}
		}
	}

	return Array.from(byId.values());
}

/**
 * Partidas del rol Barra (lista que prestan TPV / TPV+Barra / 1 en Sala).
 * Si Barra no tiene partidas asignadas → [].
 * @param {Array<{ name?: string, elaborationStations?: Array<{ id: unknown; name?: string }> }>} roles
 * @returns {Array<{ id: unknown; name?: string }>}
 */
export function collectBarraElaborationStations(roles) {
	if (!Array.isArray(roles)) {
		return [];
	}

	const barraName = normalizeCopilotRoleName(COPILOT_ROLE_NAMES.BARRA);
	const barraRole = roles.find(
		(role) => normalizeCopilotRoleName(role?.name) === barraName,
	);

	return Array.isArray(barraRole?.elaborationStations) ? [...barraRole.elaborationStations] : [];
}
